"use client";
import { useState, useEffect } from "react";
import clipboard from "clipboard-polyfill/build/clipboard-polyfill.promise";

const DEFAULT_DELAY = 2000;

const useCopyLinkToClipboard = (link, delay = DEFAULT_DELAY) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    copied && setTimeout(() => setCopied(false), delay);
  }, [copied, delay]);

  const copy = () => {
    clipboard.writeText(link);
    setCopied(true);
  };

  return [copied, copy];
};

export default useCopyLinkToClipboard;
